"use client";

import { ComponentProps } from "react";
import { useTemplateBookmark } from "src/contexts/TemplateBookmarkContext";
import { TemplateCard, useTemplateDetail } from "@zapier/templates";

export function ZapCard({
  size = "small",
  template,
  clickEventInteractionGoal,
  href,
  onClick,
  className,
  isLoggedIn = true,
  hasBookmarking = true,
}: Omit<ComponentProps<typeof TemplateCard>, "templateBookmarkActions">) {
  const {
    createUserTemplateBookmark,
    deleteUserTemplateBookmark,
    bookmarkedTemplates,
    templateBookmarkChanging,
  } = useTemplateBookmark();

  const { setUseCase, setSlug, setPrimaryProduct } = useTemplateDetail();

  const handleTemplateClick = () => {
    if (onClick && typeof onClick === "function") {
      onClick();
    } else {
      setUseCase((template.categories?.items || [])[0]?.slug || null);
      setSlug(template.slug);
      setPrimaryProduct(template.primaryProduct || null);
    }
  };

  return (
    <TemplateCard
      clickEventInteractionGoal={clickEventInteractionGoal}
      size={size}
      href={href}
      onClick={handleTemplateClick}
      className={className}
      template={template}
      isLoggedIn={isLoggedIn}
      hasBookmarking={hasBookmarking}
      templateBookmarkActions={
        hasBookmarking
          ? {
              onSave: createUserTemplateBookmark,
              onUnsave: deleteUserTemplateBookmark,
              isBookmarked: bookmarkedTemplates?.includes(template.id),
              isLoading: templateBookmarkChanging === template.id,
            }
          : undefined
      }
    />
  );
}
